<template>
    <div id="wpay" class="wpay">
        <!-- 단계 폼(params) 자동제출 — 이니시스는 iframe 연동을 지원하지 않으므로 항상 새창으로 띄운다 -->
        <form ref="form" :action="url" method="post" :target="target" style="display: none">
            <input v-for="(value, key) in params" :key="key" type="hidden" :name="key" :value="value" />
        </form>
    </div>
</template>

<script>
import api from "@/api";

// 이니시스 가이드 1.7 — 가맹점이 WPAY 화면을 iframe 으로 부르면 크로스도메인 쿠키(JSESSIONID)가
// 저장되지 않아 연동 자체가 깨지고 기술지원도 받을 수 없다. 그래서 PC·모바일 모두 새창을 쓴다.
const TARGET = "wpayPopup";
const FEATURES = "width=500,height=700,resizable=yes,scrollbars=yes";

export default {
    data() {
        return {
            url: null,
            params: {},
            target: TARGET,

            popup: null,
            watcher: null,
        };
    },
    mounted() {
        // 결과 result.vue(이니시스 복귀 → /api/plugins/wpay/auth → /plugins/wpay/result, 팝업 내부)가 호출한다.
        window.wpayComplete = (payload) => {
            this.close();
            this.$emit("complete", payload);
            this.$emit("change", payload);
            this.$emit("input", payload);
        };
        window.wpayClose = () => {
            this.close();
            this.$emit("close");
        };
    },
    beforeDestroy() {
        this.stopWatch();
        window.wpayComplete = undefined;
        window.wpayClose = undefined;
    },
    methods: {
        /**
         * 결제창을 미리 열어 둔다.
         *
         * 팝업 차단기는 "사용자 클릭에서 곧바로 이어진 window.open" 만 허용한다. 주문 생성 같은
         * 비동기 작업을 먼저 하면 그 연결이 끊겨 차단되므로, 클릭 직후에 빈 창부터 띄워 두고
         * 준비가 끝난 뒤 그 창으로 폼을 보낸다.
         *
         * @returns {boolean} 창을 확보했는지 여부
         */
        prepare() {
            if (this.popup && !this.popup.closed) return true;

            this.popup = window.open("", TARGET, FEATURES);
            return !!this.popup;
        },

        /** 미리 열어 둔 창을 쓰지 않게 됐을 때 정리한다(다른 PG가 배정된 경우). */
        release() {
            try {
                if (this.popup && !this.popup.closed) this.popup.close();
            } catch (error) {
                // 창을 닫지 못해도 결제 흐름에는 영향이 없다.
            }
            this.popup = null;
        },

        close() {
            this.stopWatch();
            this.release();
        },

        /** 사용자가 결제창을 그냥 닫은 경우를 감지해 진행중 상태를 풀어 준다. */
        startWatch() {
            this.stopWatch();
            this.watcher = setInterval(() => {
                if (this.popup && this.popup.closed) {
                    this.stopWatch();
                    this.popup = null;
                    this.$emit("close");
                }
            }, 700);
        },
        stopWatch() {
            if (this.watcher) clearInterval(this.watcher);
            this.watcher = null;
        },

        /**
         * 결제 시작: /request 로 단계 폼을 받아 새창에 자동제출한다.
         * @param {{ orderNo: string, ci: string }} [param0]
         */
        async open({ orderNo, ci } = {}) {
            if (!this.prepare()) {
                throw new Error("팝업이 차단되어 있습니다. 팝업 차단을 해제한 뒤 다시 시도해주세요.");
            }

            try {
                const { checkout } = await api.plugins.wpay.request({ orderNo, ci });

                this.url = checkout.url;
                this.params = checkout.params;

                await this.$nextTick();

                this.$refs.form.submit();
                this.popup.focus?.();

                this.startWatch();
            } catch (error) {
                this.close();
                throw error;
            }
        },
    },
};
</script>
